import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './App.css';
import EmailVerification from './containers/email-verification';
import ForgotPassword from './containers/forgot-password';
import Login from './containers/login';
import Signup from './containers/signup';
import {
  ACCESS_EXPIRED,
  FORGOT_PASSWORD,
  LOGIN,
  MESSAGE,
  NOT_VERIFIED,
  SIGNUP,
  SOURCE,
  TEMPLATE,
  URL_EXPIRED,
  VERIFY_EMAIL
} from './content/constants';
import { useQuery } from './hooks/useQuery';
import { I18nLanguageSelector } from './components';
import AuthContext from './context/AuthContext';

function App() {
  const [route, setRoute] = useState(LOGIN);
  const { i18n } = useTranslation();
  let query = useQuery();
  const { data } = useContext(AuthContext);
  useEffect(() => {
    i18n.changeLanguage(query.get('lang'));
    let message = query.get(MESSAGE);
    if (query.get(TEMPLATE) === VERIFY_EMAIL) {
      switch (message) {
        case URL_EXPIRED:
        case ACCESS_EXPIRED:
        case NOT_VERIFIED:
          setRoute(VERIFY_EMAIL);
          break;
        default:
          setRoute(query.get(SOURCE) || LOGIN);
      }
    } else {
      setRoute(query.get(SOURCE) || LOGIN);
    }
  }, [i18n, query]);

  return (
    <>
      {!data?.tenantDetail && <I18nLanguageSelector />}
      {route === LOGIN && <Login />}
      {route === SIGNUP && <Signup />}
      {route === FORGOT_PASSWORD && <ForgotPassword />}
      {route === VERIFY_EMAIL && <EmailVerification />}
    </>
  );
}

export default App;
